{
  "app": {
    "loading": {
      "title": "myDATA Comply",
      "subtitle": "Getting things ready…"
    },
    "tabs": {
      "dashboard": "Dashboard",
      "submissions": "Submissions",
      "configuration": "Configuration"
    }
  },
  "welcome": {
    "title": "Welcome to myDATA Comply!",
    "subtitle": "Thank you for installing our app. Let’s get you set up with automated myDATA submissions.",
    "whatYouGet": {
      "title": "What’s Included:",
      "trial": "7 free submissions to try it out",
      "automation": "Automatic document submission to myDATA (AADE)",
      "pdfGeneration": "PDF generation with QR code and logo",
      "realTimeTracking": "Real-time submission tracking & history",
      "support": "Technical support within 24 hours"
    },
    "nextSteps": {
      "title": "Getting Started (3 simple steps):",
      "step1": "Go to Settings and fill in your company details (VAT number, company name, address)",
      "step2": "Once you save, we receive your details and initiate the provider activation process",
      "step3": "Within ~1 business day, you’ll receive a digital authorization request from the official provider — accept it, and you’re ready to submit!"
    },
    "action": {
      "configure": "Go to Settings",
      "goToDashboard": "Go to Dashboard"
    }
  },
  "submissions": {
    "title": "Submission History",
    "subtitle": "View all myDATA submissions",
    "totalCount": "{count} total",
    "columns": {
      "order": "Order",
      "type": "Type",
      "date": "Submission Date",
      "status": "Status",
      "mark": "MARK",
      "pdf": "PDF"
    },
    "types": {
      "delivery_note": "Delivery Note",
      "receipt": "Receipt",
      "receipt_with_delivery_note": "Receipt & D.N.",
      "invoice": "Invoice",
      "invoice_with_delivery_note": "Invoice & D.N.",
      "invoice_on_behalf": "Invoice (third parties)",
      "clearance_invoice": "Clearance (third parties)",
      "receipt_on_behalf": "Receipt (third parties)",
      "credit_invoice": "Credit Invoice",
      "retail_credit_note": "Credit Note"
    },
    "status": {
      "success": "Success",
      "failure": "Failed",
      "cancelled": "Cancelled",
      "pending": "Pending"
    },
    "actions": {
      "viewPdf": "View PDF"
    },
    "documentsCount": {
      "one": "{count} document",
      "other": "{count} documents"
    },
    "pagination": {
      "footer": "Page {page} of {totalPages} (Total: {count} orders)"
    },
    "empty": {
      "title": "No submissions yet",
      "description": "Your myDATA submission history will appear here once you submit your first delivery note."
    }
  },
  "dashboard": {
    "subscription": {
      "title": "Subscription Plan",
      "freeTrial": "Free Trial",
      "basicPlan": "Comply Starter",
      "month": "month",
      "docsPerMonth": "submissions/month",
      "perDoc": "submission",
      "popular": "Popular",
      "needMore": "Need more submissions?",
      "confirmCancel": "Are you sure you want to cancel your subscription? You will keep access until the end of the period you have already paid for.",
      "status": {
        "active": "Active",
        "cancelled": "Cancelled",
        "expired": "Expired",
        "trial": "Trial"
      },
      "pricing": {
        "trial": "7 free submissions",
        "monthly": "from €9.99 / month"
      },
      "billingPeriod": "Started on",
      "actions": {
        "upgrade": "Upgrade",
        "cancel": "Cancel Subscription",
        "reactivate": "Reactivate Subscription",
        "subscribe": "Subscribe",
        "select": "Select Plan"
      },
      "cancelledBanner": "Your subscription is cancelled. You will have access until {date}.",
      "trialInfo": "Your free submissions have been used up. Please select one of our monthly plans to continue.",
      "trialActive": "You're on the free trial. Plans will appear here when your trial submissions are used up.",
      "redirecting": "Redirecting to Shopify for confirmation...",
      "notifications": {
        "activated": "Subscription activated successfully!",
        "activationFailed": "Subscription activation failed. Please try again.",
        "declined": "Subscription was declined. You can try again anytime.",
        "cancelled": "Subscription cancelled.",
        "couldNotInitiate": "Could not initiate subscription process.",
        "couldNotCancel": "Could not cancel subscription.",
        "couldNotReactivate": "Could not reactivate subscription.",
        "unknownError": "An unknown error occurred."
      }
    },
    "quota": {
      "vipBanner": {
        "title": "✨ You've got VIP status!",
        "body": "Your VIP code gave you {bonus} extra free submissions — {total} free submissions in total instead of 7!"
      },
      "title": {
        "trial": "Free Submissions",
        "subscription": "Subscription Usage"
      },
      "period": {
        "lifetime": "lifetime",
        "monthly": "this month"
      },
      "remaining": "{count} remaining",
      "remainingSingular": "{count} remaining",
      "noRemaining": "None remaining",
      "resetsOn": "Resets on: {date}",
      "trialInfo": "Your first {limit} are covered"
    },
    "productUpdates": {
      "title": "Product Updates",
      "comingSoon": "Coming Soon",
      "whatsNew": "What's New"
    },
    "currentVersion": {
      "title": "Current Version",
      "updatedOn": "Updated on {date}"
    },
    "feedback": {
      "title": "Help us improve",
      "subtitle": "Found a bug or have a question? Let us know and we'll get back to you within 24 hours.",
      "fields": {
        "type": {
          "label": "Type",
          "options": {
            "bug": "🐛 Bug Report",
            "feature": "✨ Feature Request",
            "general": "💬 General Feedback"
          }
        },
        "title": {
          "label": "Title",
          "placeholder": "Brief summary"
        },
        "description": {
          "label": "Description",
          "placeholder": "Provide details..."
        },
        "email": {
          "label": "Email (optional)",
          "placeholder": "your@email.com",
          "helpText": "For follow-up on your feedback"
        }
      },
      "submit": "Submit Feedback",
      "success": "Thank you for your feedback! We'll review it soon.",
      "error": "{message}",
      "requiredError": "Please fill in all required fields"
    },
    "contact": {
      "title": "Need help?",
      "subtitle": "We're here — call or email us directly."
    }
  },
  "settings": {
    "title": "Settings",
    "mydata": {
      "title": "myDATA Credentials",
      "subtitle": "Connect your myDATA account to enable automatic document submission",
      "expand": "Direct AADE Settings",
      "collapse": "Hide",
      "guideTitle": "How to get your myDATA API credentials",
      "guideSteps": "Follow these steps to register for the myDATA REST API:",
      "guideLink": "myDATA Guide",
      "guideStep1Before": "Visit the ",
      "guideStep1Link": "AADE myDATA API subscription page",
      "guideStep1After": " and log in with your TaxisNet credentials",
      "guideStep2Before": "Click ",
      "guideStep2Button": "Εγγραφή στο myDATA REST API",
      "guideStep2After": " (Register for myDATA REST API)",
      "guideStep3Before": "Select ",
      "guideStep3Button": "Νέα εγγραφή χρήστη",
      "guideStep3After": " (New user registration)",
      "guideStep4": "Choose a username — ideally something simple, e.g. \"mydatauser\" — and complete the registration",
      "guideStep5Before": "Copy and save your ",
      "guideStep6Before": "Enter the username you chose as your ",
      "guideStep6Middle": " and paste your ",
      "guideStep6After": " in the form below",
      "userId": {
        "label": "myDATA User ID",
        "helpText": "Your User ID from the Greek tax authority",
        "placeholder": "e.g. 123456789"
      },
      "subscriptionKey": {
        "label": "Subscription Key",
        "helpText": "Your API subscription key from the tax authority",
        "placeholder": "Enter your subscription key"
      },
      "environment": {
        "label": "Environment",
        "sandbox": "Sandbox Environment (mydataapidev.aade.gr)",
        "production": "Production Environment (mydatapi.aade.gr)",
        "helpText": "Use sandbox for testing, production for live transactions"
      }
    },
    "vip": {
      "title": "You are a VIP! 🎉",
      "subtitle": "Got a VIP code? Redeem it for extra free submissions, on us.",
      "codeLabel": "VIP code",
      "codePlaceholder": "Paste your code",
      "apply": "Apply",
      "applying": "Applying...",
      "grantedBonus": "You already have {count} bonus free submissions from a VIP code.",
      "successTitle": "Welcome to VIP status!",
      "success": "You just earned {count} extra free submissions. Total bonus: {total}."
    },
    "company": {
      "title": "Company Information",
      "subtitle": "This information will appear on your invoices",
      "vat": {
        "label": "VAT Number",
        "helpText": "9-digit Greek VAT number (required)",
        "placeholder": "999999999"
      },
      "name": {
        "label": "Official Name",
        "helpText": "Your registered company name"
      },
      "address": {
        "label": "Address",
        "helpText": "Street name and number"
      },
      "city": {
        "label": "City"
      },
      "postalCode": {
        "label": "Postal Code",
        "helpText": "5-digit postal code",
        "placeholder": "12345"
      },
      "profession": {
        "label": "Profession",
        "helpText": "e.g. Retail Trade",
        "placeholder": "Retail Trade"
      },
      "taxOffice": {
        "label": "Tax Office (DOY)",
        "helpText": "e.g. A' Athens",
        "placeholder": "A' Athens"
      },
      "gemi": {
        "label": "GEMI number",
        "helpText": "Optional. Displayed on PDF documents"
      },
      "phone": {
        "label": "Phone",
        "helpText": "Displayed on PDF documents",
        "placeholder": "210 1234567"
      },
      "email": {
        "label": "Email",
        "helpText": "Displayed on PDF documents",
        "placeholder": "info@example.gr"
      },
      "logo": {
        "label": "Company Logo URL",
        "helpText": "URL of your company logo image (will appear on PDFs)",
        "placeholder": "https://cdn.shopify.com/s/files/1/xxxx/logo.png",
        "guideTitle": "How to get your logo URL from Shopify:",
        "guideIntro": "Follow these steps to upload and get the URL of your company logo:",
        "guideStep1": "Go to your Shopify Admin →",
        "guideStep1Link": "Settings → Files",
        "guideStep2": "Click 'Upload files' and select your company logo (PNG, JPG, or SVG format recommended)",
        "guideStep3": "After upload, click on your logo file in the list",
        "guideStep4": "Click the 'Copy link' button or right-click the preview and copy the image URL",
        "guideTip": "Tip: The URL should look like https://cdn.shopify.com/s/files/... and be publicly accessible"
      },
      "defaultVatRate": {
        "label": "Default VAT Rate",
        "helpText": "Used when Shopify doesn't have VAT configured on your products. Select the rate that applies to most of your products."
      }
    },
    "vatSchemes": {
      "title": "Supported VAT Schemes",
      "subtitle": "Enable the OSS/IOSS schemes your business is registered for. All options are off by default — only activate once you have completed the corresponding registration with AADE and Shopify.",
      "ossEu": {
        "label": "OSS EU (Union scheme — intra-EU B2C sales)",
        "description": "For Greek businesses selling B2C to customers in other EU countries. When enabled, orders with an EU destination will be submitted with zero Greek VAT (art. 57 exemption) and the income classification for EU retail sales.",
        "callout": "Make sure you are registered for the OSS Union scheme with AADE and that you have enabled EU VAT collection in your Shopify Tax settings. Without both, enabling this option will produce incorrect documents."
      },
      "ossNonEu": {
        "label": "Non-EU exports (zero-rated)",
        "description": "For orders shipped to countries outside the European Union. When enabled, those orders will be submitted with zero VAT (art. 56 export exemption) and the export income classification (E3_561_005).",
        "callout": "Only enable this if your orders to non-EU countries are genuine exports that are VAT-exempt under Greek law. Confirm with your accountant before activating."
      },
      "ioss": {
        "label": "IOSS (Import One Stop Shop)",
        "description": "For goods shipped from outside the EU to EU consumers, valued at €150 or less. Requires a separate IOSS registration number.",
        "notSupported": "IOSS support is not yet available. This option will be enabled in a future update."
      }
    },
    "actions": {
      "save": "Save Settings",
      "test": "Test Connection"
    },
    "notifications": {
      "saveSuccess": "Settings saved successfully",
      "saveFailed": "Failed to save settings",
      "testSuccess": "myDATA connection successful!",
      "testFailed": "Connection test failed",
      "loadFailed": "Failed to load settings",
      "error": "An error occurred",
      "bannerSuccess": "Success",
      "bannerError": "Error"
    }
  },
  "footer": {
    "copyright": "© 2026 myDATA Comply. All rights reserved.",
    "privacy": "Privacy Policy",
    "terms": "Terms of Service",
    "support": "Support",
    "documentation": "Documentation"
  },
  "common": {
    "close": "Close"
  },
  "contractStatus": {
    "title": "Provider Contract",
    "providerActive": "Provider is active",
    "providerInactive": "Provider not yet active",
    "unsigned": {
      "title": "Contract not yet signed",
      "description": "To activate the provider you must digitally sign the contract and download it.",
      "signButton": "Sign the contract ↗",
      "downloadButton": "Download the contract"
    },
    "stale": {
      "title": "Your details changed since signing",
      "description": "The signed contract no longer matches your current details. Update your details and re-sign the contract.",
      "resignButton": "Re-sign ↗",
      "downloadPreviousButton": "Download previous signed version"
    },
    "signed": {
      "title": "Contract signed",
      "description": "Your contract is signed and your provider account is active.",
      "downloadButton": "Download signed contract"
    },
    "pending": {
      "title": "Contract received — activation pending",
      "description": "We have your signed contract and are activating your provider account. This usually takes 1–2 business days. In the meantime, please follow the AADE provider registration guide we sent to your email — you will need to complete that step before you can submit documents."
    }
  },
  "onboarding": {
    "loading": "Loading...",
    "help": {
      "title": "Need help?",
      "subtitle": "We’re here during registration — call or email us directly.",
      "phone": "698 359 6733",
      "email": "lefteris@weam.gr"
    },
    "title": "Provider Registration",
    "step": "Step {step} / 2",
    "welcome": {
      "title": "🎉 Thank you for installing myDATA Comply!",
      "subtitle": "Before you start submitting, we need a few details about your business to create the provider contract.",
      "durationBold": "~2 minutes",
      "durationText": "The process takes only {duration} — fill out a short form and digitally sign the contract.",
      "startButton": "Start Registration →"
    },
    "form": {
      "banner": "Fill in your details to create the provider contract. After submission you will receive the contract for digital signing.",
      "continueButton": "Continue →"
    },
    "signing": {
      "title": "Sign Your Contract",
      "description": "Your provider contract has been prepared with your details. Open it in a new tab to review and sign digitally — it takes about 2 minutes.",
      "signButton": "Open & Sign Contract ↗",
      "openNote": "After signing, return here and click below to continue to your dashboard.",
      "skipButton": "I’ll sign later →",
      "pendingTitle": "Contract Awaiting Signature",
      "pendingDescription": "Your contract has been sent to your email. Follow the signing link to complete the process.",
      "activationNote": "Once signed and approved, your provider account will be activated within 1–2 business days. You can track the status from your dashboard.",
      "continueDashboardButton": "Go to Dashboard →",
      "signedTitle": "Contract Signed ✓",
      "signedDescription": "Your contract has been signed. Redirecting you to the dashboard…",
      "waitingLabel": "Waiting for your signature…"
    },
    "errors": {
      "submitFailed": "Form submission failed",
      "networkError": "Network error",
      "sessionExpired": "Session expired. Reloading...",
      "completeFailed": "Failed to update status"
    }
  },
  "contractForm": {
    "section": {
      "companyDetails": "Company Details",
      "representative": "Legal Representative",
      "contact": "Contact Details",
      "serviceType": "Invoicing Service Type",
      "altProvider": "Communications Provider"
    },
    "fields": {
      "officialName": "Company Official Name",
      "tradingName": "Trading Name",
      "vatNumber": "Company VAT Number",
      "taxOffice": "Tax Office",
      "profession": "Profession",
      "professionPlaceholder": "Retail Trade",
      "address": "Address",
      "city": "City",
      "postalCode": "Postal Code",
      "representativeName": "Representative Full Name",
      "representativeVat": "Representative VAT Number",
      "contactEmail": "Contact Email",
      "contactEmailHelp": "You will receive provider activation instructions at this email after signing the contract.",
      "phone": "Phone",
      "serviceTypeLabel": "Type",
      "serviceTypes": {
        "b2b": "B2B (Business invoicing)",
        "b2c": "B2C (Retail)",
        "b2b_and_b2c": "B2B & B2C (Both)"
      },
      "b2cBannerTitle": "Legal requirement for B2C/retail:",
      "b2cBannerBody": "To issue retail receipts via myDATA, the law requires you to have an active contract with an approved communications provider (e.g. COSMOTE, VODAFONE, NOVA). Please fill in the details of the provider with whom you have a contract exactly as stated in it.",
      "altProviderName": "Name",
      "altProviderNameHelp": "e.g. COSMOTE, VODAFONE, NOVA",
      "altProviderNr": "Contract Number",
      "altProviderNrHelp": "As stated in your contract",
      "altProviderDate": "Contract Date",
      "altProviderDateHelp": "Contract start date",
      "requiredB2c": "Required for B2C"
    }
  },
  "validation": {
    "required": "Required field",
    "vatLength": "VAT number must be 9 digits",
    "emailInvalid": "A valid email is required"
  }
}